import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import AddMemberForm from '../components/family_components/AddMemberForm'
import { useFamilyStore } from '../../../store/useFamilyStore'
import { useClientStore } from '../../../store/useClientStore'
import SideBar from '../components/SideBar'
import Navbar from '../components/Navbar'
import SearchBar from '../components/SearchBar'
import ApiClient from '../../api/client'
import { Edit } from 'lucide-react'
import DeleteModal from '../components/family_components/DeleteMemberModal'
import UpdateMemberModal from '../components/family_components/UpdateMemberModal'
import { toast } from 'react-toastify'
import SummaryModal from '../components/family_components/Summary/SummaryModal'

const FamilyMembers = () => {
  const apiClient = new ApiClient()

  const { clientId } = useParams()
  const navigate = useNavigate()
  const [showAddForm, setShowAddForm] = useState(false)
  // Refresh
  const [refresh, setRefresh] = useState(0)
  const [summaryModal, setSummaryModal] = useState(false)

  const {
    familyMembers,
    loading,
    error,
    fetchFamilyMembers,
    addFamilyMember,
    color,
    setColor,
    showUpdateModal,
    showDeleteModal,
    showAddModal,
    openUpdateModal,
    openDeleteModal,
    closeUpdateModal,
    memberToDelete,
    closeDeleteModal,
  } = useFamilyStore()

  useEffect(() => {
    if (clientId) {
      fetchFamilyMembers(clientId)
    }
  }, [refresh])

  // handleRefresh
  const handleRefresh = () => {
    setRefresh((prev) => prev + 1)
  }

  const handleConfirmDelete = async () => {
    if (memberToDelete) {
      const response = await apiClient.deleteFamilyMember(memberToDelete.id)

      if (response.error) {
        // toast.error('Error deleting family member', {
        //   position: 'top-right',
        //   autoClose: 3000,
        //   theme: 'colored',
        // })
        console.error('Error deleting family member:', response.error)
      } else {
        // toast.success('Family member deleted successfully', {
        //   position: 'top-right',
        //   autoClose: 3000,
        //   theme: 'colored',
        // })
        // onCancel() // Close modal
        closeDeleteModal()
        handleRefresh()
      }

      // toast.success(`${clientToDelete?.client_name} has  been deleted successfully!`, {
      //   position: 'top-right',
      //   autoClose: 3000,
      //   theme: 'colored',
      // })
    }
  }
  if (memberToDelete) {
    console.log('Member to delete:', clientId, memberToDelete.id)
  }

  const family = familyMembers[clientId]

  console.log('family member:', familyMembers[clientId])
  console.log('Check refresh number:', refresh)

  // const handleAddMember = async (newMember) => {
  //   await addFamilyMember(clientId, newMember)
  //   setShowAddForm(false)
  // }

  const handleCancelAdd = () => {
    setShowAddForm(false)
  }

  if (loading) {
    return <div className="p-8 text-center">Loading family members...</div>
  }

  if (error) {
    return <div className="p-8 text-center text-red-500">Error: {error}</div>
  }

  if (!family) {
    return (
      <div className="bg-neutral-100 flex flex-row justify-center w-full min-h-screen">
        <div className="bg-neutral-100 w-[1440px] p-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">Family Not Found</h1>
            <button
              onClick={() => navigate('/dashboard/client')}
              className="bg-[#3d6be0] text-white px-6 py-2 rounded-lg hover:bg-blue-600"
            >
              Back to Client List
            </button>
          </div>
        </div>
      </div>
    )
  }
  const getStatusColor = (status) => {
    switch (status) {
      case 'approved':
        return 'bg-green-100 text-green-800'
      case 'underreview':
        return 'bg-yellow-100 text-yellow-800'
      case 'pending':
        return 'bg-gray-100 text-gray-800'
      default:
        return 'bg-red-200 text-red-800'
    }
  }

  return (
    <>
      <div className="flex h-screen bg-gray-100">
        <SideBar />
        <div className="flex-1 flex flex-col">
          <Navbar />
          <div className="bg-neutral-100 overflow-auto w-full p-8">
            {/* Header */}
            <div className="flex justify-between bg-white rounded-lg p-6 mb-6">
              <div className="flex items-center justify-between">
                <div>
                  <button
                    onClick={() => navigate('/dashboard/client')}
                    className="text-[#3d6be0] hover:underline mb-2 flex items-center gap-2"
                  >
                    ← Back to Client List
                  </button>
                  <h1 className="text-3xl font-bold text-black">
                    Client Family
                  </h1>
                  <p className="text-gray-600 mt-2">
                    {family.length} family member
                    {family.length !== 1 ? 's' : ''}
                  </p>
                </div>
              </div>
            </div>
            <div
              className="cursor-pointer h-8 text-left mb-4 p-1 rounded-lg text-green-900 text-md underline font-bold hover:text-blue-800"
              onClick={() => {
                setSummaryModal(true)
              }}
            >
              Summary
            </div>

            {/* Family Members Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {familyMembers[clientId].map((member) => (
                <div
                  key={member.id}
                  className="bg-white rounded-lg p-6 shadow-sm group relative"
                >
                  <div className="flex flex-col items-center text-center relative">
                    {member.client &&
                    member.relationship == 'primary applicant' ? (
                      <div className="flex flex-col items-center text-center">
                        <img
                          src={member.image}
                          alt={member.client_name}
                          className="w-20 h-20 rounded-full object-cover mb-4"
                        />
                        <h3 className="text-xl font-semibold text-black mb-2">
                          {member.client_name}
                        </h3>
                        {/* <p className="text-gray-600 mb-1">{member.client_email}</p>
                    <p className="text-gray-500 mb-1">{member.client_phone}</p> */}
                        <p className="text-sm text-gray-500 mb-1">
                          Code:{' '}
                          <span className="text-green-600 font-bold">
                            {member.client_id || '—'}
                          </span>
                        </p>
                        <p className="text-gray-600 capitalize mb-3">
                          {member.relationship}
                        </p>
                        <span
                          className={`capitalize mb-3 rounded-2xl px-3 py-1 ${getStatusColor(member.client_status)}`}
                        >
                          {member.client_status}
                        </span>
                        <p className="text-xs text-gray-400">
                          Added:{' '}
                          {new Date(member.created_at).toLocaleDateString()}
                        </p>
                        <div
                          onClick={() =>
                            navigate(
                              `/dashboard/client/${clientId}/family/${member.id}/files/`
                            )
                          }
                          className="mt-3 text-sm text-[#3d6be0] hover:underline cursor-pointer"
                        >
                          View Files →
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-col items-center text-center">
                        <img
                          src={member.image}
                          alt={member.full_name}
                          className="w-20 h-20 rounded-full object-cover mb-4"
                        />
                        <h3 className="text-xl font-semibold text-black mb-2">
                          {member.full_name}
                        </h3>
                        {/* <p className="text-gray-600 mb-1">{member.email}</p>
                    <p className="text-gray-500 mb-1">{member.phone}</p> */}
                        <p className="text-sm text-gray-500 mb-1">
                          Code:{' '}
                          <span className="text-green-600 font-bold">
                            {member.family_member_code || '—'}
                          </span>
                        </p>
                        <p className="text-gray-600 capitalize mb-3">
                          {member.relationship}
                        </p>
                        <span
                          className={`capitalize mb-3 rounded-2xl px-3 py-1 ${getStatusColor(member.status)}`}
                        >
                          {member.status ? `${member.status}` : 'No status yet'}
                        </span>
                        <p className="text-xs text-gray-400">
                          Added:{' '}
                          {new Date(member.created_at).toLocaleDateString()}
                        </p>
                        <div
                          onClick={() =>
                            navigate(
                              `/dashboard/client/${clientId}/family/${member.id}/files/`
                            )
                          }
                          className="mt-3 text-sm text-[#3d6be0] hover:underline cursor-pointer"
                        >
                          View Files →
                        </div>
                      </div>
                    )}
                  </div>
                  <button
                    onClick={() => openUpdateModal(member)}
                    className="absolute z-20 top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity text-blue-300 p-1 bg-gray-800 rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-gray-600"
                  >
                    <Edit />
                  </button>
                  {/* Delete button */}
                  <button
                    onClick={() => openDeleteModal(member)}
                    className="absolute z-20 top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-red-600"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
            {/* Add New Member Button */}
            <div className="mt-8 text-center">
              <button
                onClick={() => setShowAddForm(true)}
                className="bg-[#3d6be0] text-white px-6 py-3 rounded-lg hover:bg-blue-600 flex items-center gap-2 mx-auto transition-colors"
              >
                <span className="text-xl">+</span>
                Add New Family Member
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Reusable DeleteModal */}
      <DeleteModal
        isOpen={showDeleteModal}
        title="Confirm Delete"
        message={`Are you sure you want to delete "${memberToDelete?.full_name}"?`}
        onConfirm={handleConfirmDelete}
        onCancel={closeDeleteModal}
      />
      {/* Reusable UpdateClientModal */}
      <UpdateMemberModal onSuccess={handleRefresh} />
      {/* Add Member Form Modal */}
      {showAddForm && (
        <AddMemberForm onCancel={handleCancelAdd} onSuccess={handleRefresh} />
      )}

      {summaryModal && <SummaryModal onCancel={() => setSummaryModal(false)} />}
    </>
  )
}

export default FamilyMembers
